import React, { useEffect, useState } from "react";
import { FacebookShareButton, TwitterShareButton,WhatsappShareButton,EmailShareButton,TelegramShareButton,PinterestShareButton } from "react-share";
import { FacebookIcon, TwitterIcon,WhatsappIcon,EmailIcon,TelegramIcon,PinterestIcon } from "react-share";
import "./share.css";
import { getShareurl } from "../api/core";



const Share = (props) =>{
 const[pageType,setPageType] = useState(props.type?props.type:"season");
 const[pageImage,setPageImage] = useState(props.details?props.type==="video"?props.details.image:"":"");
 const[pageTitle,setPageTitle] = useState(props.details?props.type==="video"?props.details.title:props.details.displayName:"Smott Preview App");
 const[pageUrl,setPageUrl] =  useState(window.location.href);
 const[pageDescription,setPageDescription] =useState(props.details?props.type==="video"?props.details.description:props.details.description:"");
 const[pageID,setPageID] = useState('');
 
 useEffect(()=>{

  setPageType(props.type?props.type:"season");
  setPageImage(props.details?props.type==="video"?props.details.image:props.imaged:"");
  setPageUrl(window.location.href);
  setPageDescription(props.details?props.type==="video"?props.details.description:props.details.description:"")
  setPageTitle(props.details?props.type==="video"?props.details.title:props.details.displayName:"Smott Preview App")
  if(props.type==="season")
  {
       setPageID(props.details._id);
  }
  else
  {
       setPageID(props.details.mediaid);
  }



 },[props.details,props.type,props.imaged])

    return(
        <div className="share-box" style={{bottom:props.article?"-50px":""}}>
            <div className="d-flex align-items-center">
          <EmailShareButton
           url={getShareurl(pageType,pageUrl,pageImage,pageTitle,props.match.params.AppId,pageID)}
           quote={pageTitle}
           description={pageDescription}
           className="Demo__some-network__share-button"
          >
            <EmailIcon size={24}/>
          </EmailShareButton>

         
            <FacebookShareButton
        url={getShareurl(pageType,pageUrl,pageImage,pageTitle,props.match.params.AppId,pageID)}
        quote={pageTitle}
        description={pageDescription}
        className="Demo__some-network__share-button"
      >
        <FacebookIcon size={24} round />
      </FacebookShareButton>
      <TwitterShareButton
         url={getShareurl(pageType,pageUrl,pageImage,pageTitle,props.match.params.AppId,pageID)}
         title={pageTitle}
         description={pageDescription}
        hashtags={["hashtag1", "hashtag2"]}
        className="Demo__some-network__share-button"
      >
        <TwitterIcon size={24} round />
       
      </TwitterShareButton>
      <WhatsappShareButton
        url={getShareurl(pageType,pageUrl,pageImage,pageTitle,props.match.params.AppId,pageID)}
        title={pageTitle}
        description={pageDescription}
       hashtags={["hashtag1", "hashtag2"]}
        className="Demo__some-network__share-button"
      >
        <WhatsappIcon size={24} round />
       
      </WhatsappShareButton>
      <TelegramShareButton
           url={getShareurl(pageType,pageUrl,pageImage,pageTitle,props.match.params.AppId,pageID)}
           title={pageTitle}
           description={pageDescription}
           hashtag={"#hashtag"}          
           className="Demo__some-network__share-button"
          >
            <TelegramIcon size={24}/>
          </TelegramShareButton>

          <PinterestShareButton
           url={getShareurl(pageType,pageUrl,pageImage,pageTitle,props.match.params.AppId,pageID)}
           title={pageTitle}
           description={pageDescription}
           hashtag={"#hashtag"}
           className="Demo__some-network__share-button"
          >
            <PinterestIcon size={24}/>
          </PinterestShareButton>

          
   

            </div>
        </div>
    );
}


export default Share;